import { SHELL } from "../shell/shell.const";

const USER_ONBOARDING = 'reg';

const USER_ONBOARDING_STEP_1 = 'ine';
const USER_ONBOARDING_STEP_2 = 'id';
const USER_ONBOARDING_STEP_3 = 'informacion';
const USER_ONBOARDING_STEP_4 = 'direccion';
const USER_ONBOARDING_STEP_5 = 'contrato';
const USER_ONBOARDING_STEP_6 = 'completado';
const USER_ONBOARDING_STEP_7 = 'perfil-transaccional';

export const USER_ONBOARDING_ROUTES = {
  USER_ONBOARDING,
  USER_ONBOARDING_STEP_1,
  USER_ONBOARDING_STEP_2,
  USER_ONBOARDING_STEP_3,
  USER_ONBOARDING_STEP_4,
  USER_ONBOARDING_STEP_5,
  USER_ONBOARDING_STEP_6,
  USER_ONBOARDING_STEP_7,


  ROUTE_USER_ONBOARDING: `${SHELL}/${USER_ONBOARDING}`,
  ROUTE_USER_ONBOARDING_STEP_1: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_1}`,
  ROUTE_USER_ONBOARDING_STEP_2: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_2}`,
  ROUTE_USER_ONBOARDING_STEP_3: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_3}`,
  ROUTE_USER_ONBOARDING_STEP_4: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_4}`,
  ROUTE_USER_ONBOARDING_STEP_5: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_5}`,
  ROUTE_USER_ONBOARDING_STEP_6: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_6}`,
  ROUTE_USER_ONBOARDING_STEP_7: `${SHELL}/${USER_ONBOARDING}/${USER_ONBOARDING_STEP_7}`,
}
